
import { useState } from "react";

const portfolioItems = [
  {
    id: 1,
    title: "Royal Bridal",
    category: "Bridal",
    image: "/images/banner-sunrise.jpg",
    description:
      "Elegant bridal makeup with a timeless, radiant finish.",
  },
  {
    id: 2,
    title: "Traditional Bride",
    category: "Bridal",
    image: "/images/t-bride.webp",
    description:
      "A beautiful traditional bridal look with refined detailing.",
  },
  {
    id: 3,
    title: "Soft Glam",
    category: "Makeup",
    image: "/images/soft-glam.webp",
    description:
      "Soft glam makeup designed for a naturally flawless appearance.",
  },
//   {
//     id: 4,
//     title: "Party Glam",
//     category: "Makeup",
//     image: "/images/party-makeup.jpg",
//     description:
//       "A glamorous party look with glowing skin and beautiful definition.",
//   },
//   {
//     id: 5,
//     title: "Elegant Curls",
//     category: "Hairstyling",
//     image: "/images/hairstyling.jpg",
//     description:
//       "Soft curls and waves designed to complement your complete look.",
//   },
//   {
//     id: 6,
//     title: "Bridal Hair",
//     category: "Hairstyling",
//     image: "/images/hair-styling.jpg",
//     description:
//       "Elegant bridal hairstyling with beautiful traditional detailing.",
//   },
  {
    id: 7,
    title: "Complete Makeover",
    category: "Makeover",
    image: "/images/makeup.webp",
    description:
      "A complete transformation combining makeup, hair and styling.",
  },
  {
    id: 8,
    title: "Editorial Look",
    category: "Makeover",
    image: "/images/editorial-look.webp",
    description:
      "An editorial-inspired look designed for photoshoots and special occasions.",

  }
];

const categories = [
  "All",
  "Bridal",
  "Makeup",
  "Hairstyling",
  "Makeover",
];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredItems =
    activeCategory === "All"
      ? portfolioItems
      : portfolioItems.filter(
          (item) => item.category === activeCategory
        );

  const openLightbox = (item) => {
    setSelectedImage(item);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const currentIndex = filteredItems.findIndex(
      (item) => item.id === selectedImage.id
    );

    const nextIndex =
      currentIndex === filteredItems.length - 1
        ? 0
        : currentIndex + 1;

    setSelectedImage(filteredItems[nextIndex]);
  };

  const previousImage = () => {
    const currentIndex = filteredItems.findIndex(
      (item) => item.id === selectedImage.id
    );

    const previousIndex =
      currentIndex === 0
        ? filteredItems.length - 1
        : currentIndex - 1;

    setSelectedImage(filteredItems[previousIndex]);
  };

  return (
    <>
      <section
        id="portfolio"
        className="section py-20 md:py-28 relative overflow-hidden"
      >
        {/* Background Glow */}
        <div className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-sunrise-500/10 blur-3xl" />

          <div className="absolute bottom-0 -right-20 w-96 h-96 rounded-full bg-blush-500/10 blur-3xl" />
        </div>

        {/* Heading */}
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm uppercase tracking-[0.25em] text-sunrise-300">
            Our Portfolio
          </span>

          <h2 className="mt-3 font-display text-4xl md:text-5xl">
            Beauty looks made to{" "}
            <span className="text-sunrise-300">
              shine
            </span>
          </h2>

          <p className="mt-5 text-white/70 leading-relaxed">
            Explore our bridal, makeup, hairstyling and
            complete makeover transformations.
          </p>
        </div>

        {/* Filters */}
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {categories.map((category) => {
            const isActive = activeCategory === category;

            return (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-5 py-2.5 rounded-full text-sm transition ${
                  isActive
                    ? "bg-sunrise-500 text-white shadow-lg"
                    : "glass text-white/70 hover:text-white"
                }`}
              >
                {category}
              </button>
            );
          })}
        </div>

        {/* Portfolio Grid */}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredItems.map((item) => (
            <article
              key={item.id}
              onClick={() => openLightbox(item)}
              className="group cursor-pointer glass p-2 rounded-[28px] overflow-hidden"
            >
              <div className="relative overflow-hidden rounded-[22px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[4/5] object-cover transition duration-700 group-hover:scale-110"
                  loading="lazy"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-80" />

                {/* Hover Icon */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                  <div className="w-12 h-12 rounded-full glass flex items-center justify-center text-xl">
                    🔍
                  </div>
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="text-xs uppercase tracking-[0.2em] text-sunrise-300">
                    {item.category}
                  </span>

                  <h3 className="mt-1 font-display text-2xl">
                    {item.title}
                  </h3>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* LIGHTBOX */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            onClick={closeLightbox}
            className="absolute top-5 right-5 w-11 h-11 rounded-full glass text-white text-xl z-10"
          >
            ✕
          </button>

          {/* Previous */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              previousImage();
            }}
            className="absolute left-4 md:left-8 w-11 h-11 rounded-full glass text-white text-xl z-10"
          >
            ←
          </button>

          {/* Image */}
          <div
            className="max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="max-h-[75vh] w-full object-contain rounded-2xl"
            />

            <div className="text-center mt-5">
              <span className="text-sm text-sunrise-300 uppercase tracking-widest">
                {selectedImage.category}
              </span>

              <h3 className="font-display text-3xl mt-1">
                {selectedImage.title}
              </h3>

              <p className="mt-2 text-white/70 text-sm">
                {selectedImage.description}
              </p>
            </div>
          </div>

          {/* Next */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-4 md:right-8 w-11 h-11 rounded-full glass text-white text-xl z-10"
          >
            →
          </button>
        </div>
      )}
    </>
  );
}
